import Vue from 'vue'
import alert from './PopupPromptAlert'
import {isVNode} from "element-ui/src/utils/vdom";
import merge from "element-ui/src/utils/merge";

const Alert = Vue.extend(alert) // 创建alert组件的构造类



const alertFun = function (options) { // 接收配置
    let str_num = (typeof options === 'string' || typeof options === 'number')
    const Instance = new Alert({ // 实例化组件
        data: { // 给data的变量赋值
            title: (options && options.title) || '提示',
            message: str_num ? options : ((options && options.message) || ''),
            content: (options && options.content) || '',
            cancelText: (options && options.cancel) || '取消',
            confirmText: (options && options.confirm) || '确认'
        }
    })
    let vm = Instance.$mount() // 挂载
    document.body.appendChild(vm.$el) // 插入body
    return vm.init() // 执行初始化方法, 返回的是一个promise
}

export default {
    install: (Vue) => { // 暴露install方法供Vue.use()调用
        Vue.prototype.$alert = alertFun // 挂到Vue的原型上使用
    }
}

export { alertFun };
